module.exports = __webpack_public_path__ + "img/15.76b2f7ba.jpg";